module.exports = __webpack_public_path__ + "static/img/12.887c2be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/12.png
// module id = RwFX
// module chunks = 0